import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { isError } from "lodash";
import { getTranslationID } from "translation";
import { closeSnackbar, openSnackbar } from "../ui";
import { getBasePath } from "../../common/getConfiguration";
import { AccountApi, Configuration, GetUserResponse, UserApi } from "../../api";

export const userAsync = createAsyncThunk<
  GetUserResponse,
  { isCloseSnackbar: boolean } | undefined,
  {
    // rejectした時の返却値の型
    rejectValue: {
      /* Empty Object */
    };
  }
>("auth/userAsync", async (args, thunkApi) => {
  const { isCloseSnackbar } = args ?? { isCloseSnackbar: true };

  // apiのConfigurationを取得する
  const basePath = getBasePath();

  const config = new Configuration({ basePath });
  try {
    if (isCloseSnackbar) {
      thunkApi.dispatch(closeSnackbar());
    }

    // User情報を取得する
    const userApi = new UserApi(config);
    const { data } = await userApi.getUser();
    return data;
  } catch (e) {
    if (isAxiosError(e)) {
      if (e.response?.status === 401) {
        return thunkApi.rejectWithValue({});
      }
    }
    thunkApi.dispatch(
      openSnackbar({
        level: "error",
        message: getTranslationID("common.message.serverInternalError"),
      })
    );
    return thunkApi.rejectWithValue({});
  }
});

export const logoutAsync = createAsyncThunk<
  {
    /**/
  },
  void,
  {
    // rejectした時の返却値の型
    rejectValue: {
      /* Empty Object */
    };
  }
>("auth/logoutAsync", async (args, thunkApi) => {
  // apiのConfigurationを取得する
  const basePath = getBasePath();

  const config = new Configuration({ basePath });
  try {
    thunkApi.dispatch(closeSnackbar());
    const api = new AccountApi(config);

    await api.logout();

    // ログアウト処理
    return {};
  } catch (e) {
    thunkApi.dispatch(
      openSnackbar({
        level: "error",
        message: getTranslationID("common.message.serverInternalError"),
      })
    );
    return thunkApi.rejectWithValue({});
  }
});

const isAxiosError = (arg: unknown): arg is AxiosError => {
  if (!isError(arg)) {
    return false;
  }
  const errorValue = arg as AxiosError;
  return errorValue.isAxiosError;
};
